var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome_template",domProps:{"innerHTML":_vm._s(_vm.$user.hotel.welcome_template[_vm.$i18n.locale])}})}
var staticRenderFns = []

export { render, staticRenderFns }